import React, { Component } from 'react';

class KantoTop extends Component {
  render() {
    return (
      <div className="Kanto-top pref">
        <div>群馬</div>
        <div>栃木</div>
        <div>茨城</div>
      </div>
    );
  }
}

class KantoBot extends Component {
  render() {
    return (
      <div className="Kanto-bot">
        <div className="pref">
          <div>埼玉</div>
          <div>東京</div>
          <div>神奈川</div>
        </div>
        <div className="pref">
          <div>千葉</div>
        </div>
      </div>
    );
  }
}


class Kanto extends Component {

  render() {

    return (
      <div className="Kanto">
        <KantoTop />
        <KantoBot />
      </div>
    );
  }

}

export default Kanto;
